<div cdkTrapFocus cdkTrapFocusAutoCapture="true">
@if (title) {
<div class="modal-header">
  <h1 id="modal-header-title" class="modal-header-title">{{ title }}</h1>
  @if (hasClose) {
  <cross (click)="close()"></cross>
  }
</div>
}
<div class="modal-body">
  <div class="txt" [ngClass]="textAlignLeft ? '' : 'text-center'">
    @if (textHeading) {
    <p class="text-heading">{{ textHeading }}</p>
    } @if (text) {
    <p>{{ text }}</p>
    } @if (textBold) {
    <p class="bold">{{ textBold }}</p>
    } @if (textHtml) {
    <div [innerHTML]="textHtml"></div>
    }
  </div>
</div>
<div class="modal-footer">
  <div class="buttons-box">
    <span class="buttons-box-content">{{ closeInfoContent }}</span>
    <button class="fto-legacy-btn btn btn-primary" type="button" cdkFocusInitial (click)="onConfirm()" data-dismiss="modal">
      {{ closeText ? closeText : 'Ok' }}
    </button>
  </div>
</div>
</div>
